export function useMintComponentHeading({
  isAuthenticatedWithAPI,
  hasPresale,
  hasPresaleAccess,
  isSaleInMoreThanADay,
  isSaleRunning,
  isSoldOut,
  saleEnded,
  isPresale,
  canMintSale,
}: {
  isAuthenticatedWithAPI: boolean;
  hasPresale: boolean;
  hasPresaleAccess: boolean;
  isSaleInMoreThanADay: boolean;
  saleEnded: boolean;
  isSoldOut: boolean;
  isSaleRunning: boolean;
  isPresale: boolean;
  canMintSale: boolean;
}): { message: string; showTimer: boolean } | null {
  const saleStartsMessage = isSaleInMoreThanADay ? 'Starts on' : 'Starts in';

  const publicSaleMessage = isSaleInMoreThanADay
    ? 'Public Sale starts on'
    : 'Public Sale starts in';
  const presaleMessage = isSaleInMoreThanADay ? 'Presale starts on' : 'Presale starts in';

  if (saleEnded || isSoldOut) return null;

  if (!isSaleRunning) {
    return {
      message: isPresale ? presaleMessage : hasPresale ? publicSaleMessage : saleStartsMessage,
      showTimer: true,
    };
  }

  // Sale has started
  if (isAuthenticatedWithAPI && hasPresaleAccess && !canMintSale) {
    return {
      message: "You've hit the cap!",
      showTimer: false,
    };
  }

  return null;
}
